import React from 'react';

import Modal from 'react-modal';

import {
    ModalEconomiaContenido,
    ModalEconomiaCabecera,
    ModalEconomiaTitulo,
    ModalEconomiaSubtitulo,
    BotonCerrarModal,

    ModalResumenGrid,
    ModalResumenItem,
    ModalResumenLabel,
    ModalResumenValor,

    ModalSeccion,
    ModalSeccionTitulo,

    ModalFila,
    ModalFilaNombre,
    ModalFilaValor,

    ModalAviso,
    ModalAcciones,

    BotonSecundario,
    EstadoBadge
} from '../../Css/StyledEstadisticasCobros.js';


Modal.setAppElement('#root');


/*
====================================
FORMATEAR DINERO
====================================
*/

const formatMoney = (value) => {

    return new Intl.NumberFormat(
        'es-AR',
        {
            style: 'currency',
            currency: 'ARS',
            maximumFractionDigits: 0
        }
    ).format(
        Number(value || 0)
    );

};


/*
====================================
FORMATEAR FECHA
====================================
*/

const formatDate = (dateString) => {

    if (!dateString) {
        return '—';
    }

    const [
        year,
        month,
        day
    ] = dateString.split('-');

    return `${day}/${month}/${year}`;
};


/*
====================================
ESTADO TURNO
====================================
*/

const getEstadoTurnoLabel = (estado) => {

    switch (estado) {

        case 'REALIZADO':
            return 'Realizado';

        case 'CANCELADO':
            return 'Cancelado';

        case 'NO_ASISTIO':
            return 'No asistió';

        case 'PENDIENTE':
            return 'Pendiente';

        default:
            return estado || '—';
    }

};


/*
====================================
ESTADO PAGO
====================================
*/

const getEstadoPagoLabel = (estado) => {

    switch (estado) {

        case 'COBRADO':
            return 'Cobrado';

        case 'PARCIAL':
            return 'Parcial';

        case 'PENDIENTE':
            return 'Pendiente';

        case 'NO_COBRABLE':
            return 'No cobrar';

        case 'SIN_CARGO':
            return 'Sin cargo';

        default:
            return estado || 'Sin cargo';
    }

};


/*
====================================
MODAL DETALLE ECONÓMICO
====================================
*/

const CobroDetalleModal = ({
    isOpen,
    onClose,
    turno,
    onCambiarCobrable,
    cambiandoCobrable
}) => {

    if (!turno) {
        return null;
    }


    const tieneCargo =
        Boolean(
            turno.tiene_cargo
        );


    const cobrable =
        Boolean(
            turno.cobrable
        );


    const estadoPago =
        turno.estado_pago ||
        'SIN_CARGO';

    /*
    ====================================
    CAMBIAR ESTADO COBRABLE
    ====================================
    */

    const handleCambiarCobrable =
        async () => {

            if (
                !tieneCargo ||
                !turno.cargo_id ||
                typeof onCambiarCobrable !==
                    'function'
            ) {
                return;
            }


            await onCambiarCobrable({
                cargo_id:
                    turno.cargo_id,

                cobrable:
                    !cobrable
            });

        };


    return (

        <Modal
            isOpen={isOpen}

            onRequestClose={onClose}

            shouldCloseOnOverlayClick={true}

            shouldCloseOnEsc={true}

            style={{
                overlay: {
                    zIndex: 2000,
                    backgroundColor:
                        'rgba(0, 0, 0, 0.45)',

                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',

                    padding: '1rem'
                },

                content: {
                    position: 'relative',

                    inset: 'auto',

                    border: 'none',
                    background: 'transparent',

                    padding: 0,

                    width: '100%',
                    maxWidth: '650px',

                    maxHeight: '90vh',

                    overflowY: 'auto',
                    overflowX: 'hidden',

                    boxSizing: 'border-box'
                }
            }}
        >

            <ModalEconomiaContenido>


                {/*
                ====================================
                CABECERA
                ====================================
                */}

                <ModalEconomiaCabecera>

                    <div>

                        <ModalEconomiaTitulo>
                            Detalle económico
                        </ModalEconomiaTitulo>

                        <ModalEconomiaSubtitulo>

                            Sesión del {
                                formatDate(
                                    turno.fecha_turno
                                )
                            }

                        </ModalEconomiaSubtitulo>

                    </div>


                    <BotonCerrarModal
                        type="button"
                        onClick={onClose}
                    >
                        ×
                    </BotonCerrarModal>

                </ModalEconomiaCabecera>


                {/*
                ====================================
                DATOS DEL TURNO
                ====================================
                */}

                <ModalResumenGrid>

                    <ModalResumenItem>

                        <ModalResumenLabel>
                            Fecha
                        </ModalResumenLabel>

                        <ModalResumenValor>
                            {
                                formatDate(
                                    turno.fecha_turno
                                )
                            }
                        </ModalResumenValor>

                    </ModalResumenItem>


                    <ModalResumenItem>

                        <ModalResumenLabel>
                            Horario
                        </ModalResumenLabel>

                        <ModalResumenValor>

                            {
                                turno.hora_inicio ||
                                '—'
                            }

                            {
                                turno.hora_fin
                                    ? ` - ${turno.hora_fin}`
                                    : ''
                            }

                        </ModalResumenValor>

                    </ModalResumenItem>


                    <ModalResumenItem>

                        <ModalResumenLabel>
                            Estado
                        </ModalResumenLabel>

                        <ModalResumenValor>

                            <EstadoBadge
                                $tipo={
                                    turno.estado_turno
                                }
                            >

                                {
                                    getEstadoTurnoLabel(
                                        turno.estado_turno
                                    )
                                }

                            </EstadoBadge>

                        </ModalResumenValor>

                    </ModalResumenItem>


                    <ModalResumenItem>

                        <ModalResumenLabel>
                            Honorarios
                        </ModalResumenLabel>

                        <ModalResumenValor>

                            {
                                turno.honorarios !==
                                null &&
                                turno.honorarios !==
                                undefined &&
                                turno.honorarios !== ''

                                    ? formatMoney(
                                        turno.honorarios
                                    )

                                    : '—'
                            }

                        </ModalResumenValor>

                    </ModalResumenItem>

                </ModalResumenGrid>


                {/*
                ====================================
                INFORMACIÓN ECONÓMICA
                ====================================
                */}

                <ModalSeccion>

                    <ModalSeccionTitulo>
                        Situación económica
                    </ModalSeccionTitulo>


                    <ModalFila>

                        <ModalFilaNombre>
                            Cargo generado
                        </ModalFilaNombre>

                        <ModalFilaValor>
                            {tieneCargo ? 'Sí' : 'No'}
                        </ModalFilaValor>

                    </ModalFila>


                    {tieneCargo ? (

                        <>

                            <ModalFila>

                                <ModalFilaNombre>
                                    Importe del cargo
                                </ModalFilaNombre>

                                <ModalFilaValor>

                                    {
                                        formatMoney(
                                            turno.importe_cargo
                                        )
                                    }

                                </ModalFilaValor>

                            </ModalFila>


                            <ModalFila>

                                <ModalFilaNombre>
                                    ¿Se cobra?
                                </ModalFilaNombre>

                                <ModalFilaValor>
                                    {
                                        cobrable
                                            ? 'Sí'
                                            : 'No'
                                    }
                                </ModalFilaValor>

                            </ModalFila>


                            <ModalFila>

                                <ModalFilaNombre>
                                    Estado del pago
                                </ModalFilaNombre>

                                <ModalFilaValor>

                                    <EstadoBadge
                                        $tipo={
                                            estadoPago
                                        }
                                    >

                                        {
                                            getEstadoPagoLabel(
                                                estadoPago
                                            )
                                        }

                                    </EstadoBadge>

                                </ModalFilaValor>

                            </ModalFila>


                            <ModalFila>

                                <ModalFilaNombre>
                                    Total pagado
                                </ModalFilaNombre>

                                <ModalFilaValor>

                                    {
                                        formatMoney(
                                            turno.total_imputado
                                        )
                                    }

                                </ModalFilaValor>

                            </ModalFila>


                            <ModalFila>

                                <ModalFilaNombre>
                                    Saldo pendiente
                                </ModalFilaNombre>

                                <ModalFilaValor>

                                    {
                                        cobrable
                                            ? formatMoney(
                                                turno.saldo_pendiente
                                            )
                                            : '—'
                                    }

                                </ModalFilaValor>

                            </ModalFila>

                        </>

                    ) : (

                        <ModalAviso>

                            Esta sesión no tiene un cargo
                            económico asociado.

                            Puede tratarse de un turno
                            pendiente o de una sesión que
                            todavía no generó honorarios.

                        </ModalAviso>

                    )}

                </ModalSeccion>


                {!cobrable && tieneCargo ? (

                    <ModalAviso>

                        El cargo conserva su importe
                        histórico, pero está marcado
                        como “No cobrar”, por lo que
                        actualmente no genera deuda.

                    </ModalAviso>

                ) : null}


                <ModalAcciones>

                    {tieneCargo ? (
                        <BotonSecundario
                            type="button"
                            onClick={handleCambiarCobrable}
                            disabled={cambiandoCobrable}
                        >
                            {
                                cambiandoCobrable
                                    ? 'Guardando...'
                                    : cobrable
                                        ? 'Marcar como no cobrar'
                                        : 'Volver a cobrar'
                            }
                        </BotonSecundario>
                    ) : null}
                    <BotonSecundario
                        type="button"
                        onClick={onClose}

                        disabled={
                            cambiandoCobrable
                        }
                    >
                        Cerrar
                    </BotonSecundario>
                </ModalAcciones>
            </ModalEconomiaContenido>

        </Modal>

    );

};


export default CobroDetalleModal;